import { Typography } from "@mui/material";
import styles from "./index.module.css";
import { CorePaper, CoreSkeletonWrapper, CoreTitleCard } from "../../core";
import { ConditionalWrapper } from "../../wrapper";
import { useMobileLayout } from "../../hooks";
import { CoreTitleCardProps } from "../../core/card/TitleCard";

type StepDescriptionProps = {
	children: React.ReactNode;
	loading?: boolean;
};

export default function StepDescription({ children, loading }: StepDescriptionProps) {
	return (
		<CoreSkeletonWrapper loading={loading}>
			<Typography className={styles.stepDescription}>{children}</Typography>
		</CoreSkeletonWrapper>
	);
}

/**Handles Mobile Layout */
export function StepWrapper({ children }: { children: React.ReactNode }) {
	const isMobileLayout = useMobileLayout();
	return (
		<ConditionalWrapper
			condition={isMobileLayout}
			whenTrue={(children) => (
				<CorePaper component={"section"} className={styles.stepPaper}>
					{children}
				</CorePaper>
			)}
		>
			{children}
		</ConditionalWrapper>
	);
}

export type StepTitleCardProps = {
	title?: React.ReactNode;
	description?: React.ReactNode;
} & Omit<CoreTitleCardProps, "title" | "description">;

export function StepTitleCard({ title, description, ...props }: StepTitleCardProps) {
	return (
		<CoreTitleCard
			{...props}
			className={`${styles.modalTitle} ${props?.className || ""}`}
			title={title}
			description={description}
			slotProps={{
				...props?.slotProps,
				title: {
					sx: { color: "#42296E", ...props?.slotProps?.title?.sx },
					...props?.slotProps?.title,
				},
				text: { style: { gap: "5px", ...props?.slotProps?.text?.style }, ...props?.slotProps?.text },
			}}
		/>
	);
}
